import { createSlice } from '@reduxjs/toolkit';
import endPoints from '../api/endpoint';
import store from './store';
import { getApiCall, postApiCall, putApiCall } from '../api/methods';
import { DashboardState } from '../types';
import { SetDashboardAccess, setCommonDataLoader } from './commonSlice';
import { notify } from '../Utils/toastify';
import { colorsClassNames, colorsNames } from '../Utils/constantData';

const initialState: DashboardState = {
  studioList: {},
  studioSpendingGraph: {},
  productionList: {},
  setList: {},
  episodeList: {},
  loading: false,
  locationList: {},
  spendings: {},
  selectedStudio: {},
  selectedProduction: {},
  selectedLocation: {},
  selectedSet: {},
  selectedEpisode: {},
  entityDetail: {},
  dashboardPiaChart: [],
  dailyDeptSpendings: {},
  departmentLineGraphData: {},
  departmentPaiChartData: {},
  approvers: [],
  dashboardPieChartData: {},
};
const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    setStudioListings: (state, action) => {
      const { payload }: any = action;
      state.studioList = payload;
    },
    setProductionListings: (state, action) => {
      const { payload }: any = action;
      state.productionList = payload;
    },
    setSetListings: (state, action) => {
      const { payload }: any = action;
      state.setList = payload;
    },
    setEpisodeListings: (state, action) => {
      const { payload }: any = action;
      state.episodeList = payload;
    },
    setLoading: (state, action) => {
      const { payload }: any = action;
      state.loading = payload;
    },
    setLocationListings: (state, action) => {
      const { payload }: any = action;
      state.locationList = payload;
    },
    setStudioSpendingGraph: (state, action) => {
      const { payload }: any = action;
      state.studioSpendingGraph = payload;
    },
    setSpendings: (state, action) => {
      const { payload }: any = action;
      state.spendings = payload;
    },
    setSelectedStudio: (state, action) => {
      const { payload }: any = action;
      state.selectedStudio = payload;
    },
    setSelectedProduction: (state, action) => {
      const { payload }: any = action;
      state.selectedProduction = payload;
    },
    setSelectedEpisode: (state, action) => {
      const { payload }: any = action;
      state.selectedEpisode = payload;
    },
    setSelectedLocation: (state, action) => {
      const { payload }: any = action;
      state.selectedLocation = payload;
    },
    setSelectedSet: (state, action) => {
      const { payload }: any = action;
      state.selectedSet = payload;
    },
    setEntityDetail: (state, action) => {
      const { payload }: any = action;
      state.entityDetail = payload;
    },
    setSpendingPieChart: (state, action) => {
      const { payload }: any = action;
      state.dashboardPiaChart = payload;
    },
    setDailyDeptSpendings: (state, action) => {
      const { payload }: any = action;
      state.dailyDeptSpendings = payload;
    },
    setDepartmentLineGraphData: (state, action) => {
      const { payload }: any = action;
      state.departmentLineGraphData = payload;
    },
    setDepartmentPaiData: (state, action) => {
      const { payload }: any = action;
      state.departmentPaiChartData = payload;
    },
    setOrderSettingData: (state, action) => {
      const { payload }: any = action;
      console.log('orderSettingData =>', payload);
      state.approvers = payload.approvers;
    },
    setDashboardPiechartData: (state, action) => {
      const { payload }: any = action;
      state.dashboardPieChartData = payload;
    },
  },
});

export const {
  setStudioListings,
  setProductionListings,
  setSetListings,
  setEpisodeListings,
  setLocationListings,
  setStudioSpendingGraph,
  setSpendings,
  setSelectedStudio,
  setSelectedEpisode,
  setSelectedLocation,
  setSelectedProduction,
  setSelectedSet,
  setLoading,
  setEntityDetail,
  setSpendingPieChart,
  setDailyDeptSpendings,
  setDepartmentLineGraphData,
  setDepartmentPaiData,
  setOrderSettingData,
  setDashboardPiechartData,
} = dashboardSlice.actions;

export default dashboardSlice.reducer;

export const getProductionListingforDropdown = (
  setSecondDropdownOptions?: any,
) => {
  const { dispatch } = store;
  dispatch(setCommonDataLoader(true));
  getApiCall(
    endPoints.production.productionNameList,
    (s: any) => {
      const { data } = s;
      console.log(data, 'dataaaa');
      if (data?.data) {
        dispatch(setProductionListings(data?.data));
        // cb(data.data.studios[0].name)
        if (setSecondDropdownOptions) {
          setSecondDropdownOptions(data.data.productions);
        }
      }
      dispatch(setCommonDataLoader(false));
    },

    (_e: any): void => undefined,
  );
};

export const getAllProductionList = (
  query = '?page=1&limit=12',
  cb?: any,
  setHasMore?: any,
  isModal?: boolean | any,
) => {
  const { dispatch } = store;
  // dispatch(setCommonDataLoader(true))

  // Build the API endpoint with the query and studioId
  const apiendpoint = `${endPoints.production.productionDashList}${query}`;
  // Make the API call
  getApiCall(
    apiendpoint,
    (s: any) => {
      const { data } = s;
      if (data.data) {
        if (isModal) {
          const currentData = data.data.productions;
          cb(currentData);

          // Determine if there is more data
          if (setHasMore) {
            const hasMore = currentData.length === 12; // If less than 10, no more data
            setHasMore(hasMore);
          }
          // cb((prev: any) => [...prev, ...data.data.data])
        } else {
          dispatch(setProductionListings(data.data));
        }
        cb && cb(data.data.productions);
        // cb(data?.data?.depts)
      }
      // Stop loading indicator
      // dispatch(setCommonDataLoader(false))
    },
    (_e: any) => {
      // Handle error, stop loading
      if (cb) cb([]); // Pass empty array on error
      if (setHasMore) setHasMore(false);
      // dispatch(setCommonDataLoader(false))
    },
  );
};

export const getAllSetList = (
  query = '?page=1&limit=12',
  cb?: any,
  setHasMore?: any,
  isModal?: boolean | any,
) => {
  const { dispatch } = store;
  // dispatch(setCommonDataLoader(true))

  // Build the API endpoint with the query and studioId
  const apiendpoint = `${endPoints.set.setDashList}${query}`;
  // Make the API call
  getApiCall(
    apiendpoint,
    (s: any) => {
      const { data } = s;
      if (data.data) {
        if (isModal) {
          const currentData = data.data.sets;
          cb(currentData);

          // Determine if there is more data
          if (setHasMore) {
            const hasMore = currentData.length === 12; // If less than 10, no more data
            setHasMore(hasMore);
          }
          // cb((prev: any) => [...prev, ...data.data.data])
        } else {
          dispatch(setSetListings(data.data));
        }

        cb && cb(data?.data?.sets);
      }
      // Stop loading indicator
      // dispatch(setCommonDataLoader(false))
    },
    (e: any) => {
      // Handle error, stop loading
      if (cb) cb([]); // Pass empty array on error
      if (setHasMore) setHasMore(false);
      // dispatch(setCommonDataLoader(false))
      notify(e?.data?.message, 'error');
    },
  );
};

export const getAllEpisodeList = (
  query = '?page=1&limit=12',
  cb?: any,
  setHasMore?: any,
  isModal?: boolean | any,
) => {
  const { dispatch } = store;
  // dispatch(setCommonDataLoader(true))

  // Build the API endpoint with the query and studioId
  const apiendpoint = `${endPoints.episode.episodeDashList}${query}`;
  // Make the API call
  getApiCall(
    apiendpoint,
    (s: any) => {
      const { data } = s;
      if (data.data) {
        if (isModal) {
          const currentData = data.data.episodes;
          cb(currentData);

          // Determine if there is more data
          if (setHasMore) {
            const hasMore = currentData.length === 12; // If less than 10, no more data
            setHasMore(hasMore);
          }
          // cb((prev: any) => [...prev, ...data.data.data])
        } else {
          dispatch(setEpisodeListings(data.data));
        }

        cb && cb(data?.data?.episodes);
      }
      // Stop loading indicator
      // dispatch(setCommonDataLoader(false))
    },
    (e: any) => {
      // Handle error, stop loading
      notify(e?.data?.message, 'error');
      if (cb) cb([]); // Pass empty array on error
      if (setHasMore) setHasMore(false);
      // dispatch(setCommonDataLoader(false))
    },
  );
};

export const getAllLocationList = (
  query = '?page=1&limit=10',
  cb?: any,
  setHasMore?: any,
  isModal?: boolean | any,
) => {
  const { dispatch } = store;
  // dispatch(setCommonDataLoader(true))

  // Build the API endpoint with the query and studioId
  const apiendpoint = `${endPoints.location.locationDashList}${query}`;
  // Make the API call
  getApiCall(
    apiendpoint,
    (s: any) => {
      const { data } = s;
      if (data.data) {
        if (isModal) {
          const currentData = data.data.locations;
          cb(currentData);

          // Determine if there is more data
          if (setHasMore) {
            const hasMore = currentData.length === 10; // If less than 10, no more data
            setHasMore(hasMore);
          }
          // cb((prev: any) => [...prev, ...data.data.data])
        } else {
          dispatch(setLocationListings(data.data));
        }

        cb && cb(data?.data?.locations);
      }
      // Stop loading indicator
      // dispatch(setCommonDataLoader(false))
    },
    (e: any) => {
      // Handle error, stop loading
      notify(e?.data?.message, 'error');
      if (cb) cb([]); // Pass empty array on error
      if (setHasMore) setHasMore(false);
      // dispatch(setCommonDataLoader(false))
    },
  );
};

export const getSetListingforDropdown = (setSecondDropdownOptions?: any) => {
  const { dispatch } = store;
  dispatch(setCommonDataLoader(true));
  getApiCall(
    `${endPoints.set.setDashList}?limit=${100}`,
    (s: any) => {
      const { data } = s;
      if (data.data) {
        dispatch(setSetListings(data.data));
        // cb(data.data.studios[0].name)
        setSecondDropdownOptions(data.data.sets);
      }
      dispatch(setCommonDataLoader(false));
    },

    (e: any) => {
      notify(e?.data?.message, 'error');
    },
  );
};

export const getEpisodeListingforDropdown = (
  setSecondDropdownOptions?: any,
  page?: any,
  EpisodeSearchQuery?: any,
) => {
  const { dispatch } = store;
  dispatch(setCommonDataLoader(true)); // Show loader during API call
  dispatch(setLoading(true));
  console.log(page, 'isme aa rhe page');

  // Construct the URL dynamically
  const baseURL = `${endPoints.webEpisodes}?limit=10&page=${page || 1}`;
  const searchQueryParam = EpisodeSearchQuery
    ? `&searchKey=${EpisodeSearchQuery}`
    : '';
  const apiURL = `${baseURL}${searchQueryParam}`;

  getApiCall(
    apiURL,
    (response: any) => {
      const { data } = response;
      if (data.data) {
        dispatch(setLoading(false));
        dispatch(setCommonDataLoader(false));
        dispatch(setEpisodeListings(data.data)); // Update the Redux store with the fetched data
        if (setSecondDropdownOptions) {
          setSecondDropdownOptions(data.data.episodes); // Update the dropdown options if callback is provided
        }
      }
      // dispatch(setCommonDataLoader(false)); // Hide loader after successful API call
    },
    (error: any) => {
      console.error('Error fetching episode listings:', error);
      dispatch(setCommonDataLoader(false)); // Hide loader in case of an error
      dispatch(setLoading(false));
    },
  );
};

export const getLocationListingforDropdown = (
  setSecondDropdownOptions?: any,
) => {
  const { dispatch } = store;
  dispatch(setCommonDataLoader(true));
  getApiCall(
    `${endPoints.location.locationDashList}?limit=${10}`,
    (s: any) => {
      const { data } = s;
      // console.log(data.data, 'lejkbfjebfjhebfjhevbk')
      if (data.data) {
        dispatch(setLocationListings(data.data));
        // cb(data.data.studios[0].name)
        setSecondDropdownOptions(
          data.data.locations.map((item: any) => ({
            _id: item._id,
            name: item.address.locationName,
          })),
        );
      }
      dispatch(setCommonDataLoader(false));
    },

    (e: any) => {
      dispatch(setCommonDataLoader(false));
      notify(e?.data?.message, 'error');
    },
  );
};

export const getStudioListingforDropdown = (
  cb?: any,
  setSecondDropdownOptions?: any,
) => {
  const { dispatch } = store;
  dispatch(setCommonDataLoader(true));
  getApiCall(
    endPoints.studio.studiodashlist,
    (s: any) => {
      const { data } = s;
      if (data.data) {
        // getStudioList(`?page=1&limit=6`, data.data.studios[0]._id,"");
        dispatch(setStudioListings(data.data));
        cb(data.data.studios[0].name);
        setSecondDropdownOptions(data.data.studios);
      }
      dispatch(setCommonDataLoader(false));
    },

    (e: any) => {
      notify(e?.data?.message, 'error');
    },
  );
};

export const getSpendings = (
  type?: any,
  id?: string,
  modelEntityId?: any,
  modelEntityType?: any,
  productionId?: any,
) => {
  const { dispatch } = store;
  dispatch(setCommonDataLoader(true));

  let endPoint = endPoints.dashBoard.spendings;

  //if (type === 'production') {
  endPoint = `${endPoint}?entityType=${type}&entityId=${id}&${
    modelEntityType ? `modelEntityType=${modelEntityType}` : ''
  }&${modelEntityId ? `modelEntityId=${modelEntityId}` : ''}&${
    productionId ? `productionId=${productionId}` : ''
  }`;
  // }

  getApiCall(
    endPoint,
    (s: any) => {
      const { data } = s;
      if (data.data) {
        // getStudioList(`?page=1&limit=6`, data.data.studios[0]._id,"");
        dispatch(setSpendings(data.data));
        // setSecondDropdownOptions(data.data.studios)
      }
      dispatch(setCommonDataLoader(false));
    },

    (e: any) => {
      notify(e?.data?.message, 'error');
    },
  );
};

export const getRequestEntityList = (
  query = '?page=1&limit=12',
  selectedTab = 'studios',
  cb?: any,
  isModal?: boolean | any,
) => {
  const { dispatch } = store;
  dispatch(setCommonDataLoader(true));

  // Build the API endpoint with the query and studioId
  const apiendpoint = `${endPoints.requestEntityList}${query}`;

  // Make the API call
  getApiCall(
    apiendpoint,
    (s: any) => {
      const { data } = s;
      if (data.data) {
        if (isModal) {
          let currentData;
          if (selectedTab === 'studios') {
            currentData = data.data.studios;
          } else if (selectedTab === 'episodes') {
            currentData = data.data.episodes;
          } else if (selectedTab === 'productions') {
            currentData = data.data.productions;
          } else if (selectedTab === 'sets') {
            currentData = data.data.sets;
          } else if (selectedTab === 'locations') {
            currentData = data.data.locations;
          }

          cb(currentData);
        }
      }
      // Stop loading indicator
      dispatch(setCommonDataLoader(false));
    },
    (e: any) => {
      notify(e?.data?.message, 'error');
      if (cb) cb([]); // Pass empty array on error

      dispatch(setCommonDataLoader(false));
    },
  );
};

export const getRequestEntityDetail = (value: any, cb?: any) => {
  const { dispatch } = store;
  dispatch(setCommonDataLoader(true));
  const { entityType, entityId } = value;
  console.log(value, 'location');
  // Build the API endpoint with the query and studioId
  const apiendpoint = `${endPoints.requestEntityDetail}?entityType=${entityType}&entityId=${entityId}`;

  // Make the API call
  getApiCall(
    apiendpoint,
    (s: any) => {
      const { data } = s;
      if (data.data) {
        console.log(data, 'data');
        dispatch(setEntityDetail(data?.data[0]));
      }
      // Stop loading indicator
      dispatch(setCommonDataLoader(false));
    },
    (e: any) => {
      notify(e?.data?.message, 'error');
      if (cb) cb([]); // Pass empty array on error

      dispatch(setCommonDataLoader(false));
    },
  );
};

export const sendRequest = (values: any, cb?: any) => {
  // return (dispatch: any, getState: any) => {
  console.log('dataToSend', values);
  // dispatch(setCommonDataLoader(true))
  postApiCall(
    endPoints.sendRequest,
    values,
    (s: any) => {
      const {
        data: { statusCode, message },
      } = s;

      console.log('RESSS', s);
      if (statusCode && statusCode === 200) {
        notify(message, 'success');
        if (cb) cb();
      }
    },
    (e: any) => {
      if (e?.data && e?.data.message) {
        notify(e?.data.message, 'error');
      }
    },
  );
  // }
};

// setSpendingPieChart

export const getStudioPieChartSpendings = (
  entityType?: any,
  entityId?: any,
  modelEntityId?: any,
  modelEntityType?: any,
  fromDate?: number,
  toDate?: number,
) => {
  const { dispatch } = store;
  dispatch(setCommonDataLoader(true));

  // Backward-compatible guard:
  // Some call-sites historically called getStudioPieChartSpendings(studioId)
  // which would shift args and produce entityId=undefined.
  let resolvedEntityType = entityType;
  let resolvedEntityId = entityId;
  if (
    typeof resolvedEntityType === 'string' &&
    (resolvedEntityId === undefined || resolvedEntityId === null) &&
    resolvedEntityType !== 'studios' &&
    /^[a-f0-9]{24}$/i.test(resolvedEntityType)
  ) {
    resolvedEntityId = resolvedEntityType;
    resolvedEntityType = 'studios';
  }

  const params = new URLSearchParams();
  if (resolvedEntityType) params.set('entityType', String(resolvedEntityType));
  if (resolvedEntityId) params.set('entityId', String(resolvedEntityId));
  if (modelEntityType) params.set('modelEntityType', String(modelEntityType));
  if (modelEntityId) params.set('modelEntityId', String(modelEntityId));
  if (fromDate) params.set('fromDate', String(fromDate));
  if (toDate) params.set('toDate', String(toDate));

  const endPoint = `${
    endPoints.production.studioPiaChartData
  }?${params.toString()}`;

  getApiCall(
    endPoint,
    (s: any) => {
      const { data } = s;
      if (data.data) {
        dispatch(
          setSpendingPieChart(
            [...data.data.topFiveSpendings, ...data.data.others]?.map(
              (item: any, i: number) => ({
                ...item,
                className: colorsClassNames[i],
                color: colorsNames[i],
              }),
            ),
          ),
        );
        // setSecondDropdownOptions(data.data.studios)
      }
      dispatch(setCommonDataLoader(false));
    },

    (e: any) => {
      notify(e?.data?.message, 'error');
    },
  );
};

export const getProdAndSetPieChartSpendings = (
  id?: any,
  type?: string,
  productionType?: string,
  fromDate?: number,
  toDate?: number,
) => {
  const { dispatch } = store;
  dispatch(setCommonDataLoader(true));

  console.log('productionType', productionType);

  const dateParams = `${fromDate ? `&fromDate=${fromDate}` : ''}${
    toDate ? `&toDate=${toDate}` : ''
  }`;

  let endPoint = endPoints.production.spendingPiaChartData;
  const TvSeriesEndPoint = `${endPoints.production.productionEpisodeTop5}?productionId=${id}${dateParams}`;
  if (type === 'production') {
    endPoint +=
      `?page=1&limit=5` +
      `&productionId=${id}&filterType=` +
      `production_schedule${dateParams}`;
  } else if (type === 'set') {
    endPoint = '';
    endPoint = `${endPoints.set.setTopFiveLocationSpending}?setId=${id}${dateParams}`;
  }

  getApiCall(
    productionType === 'TV Series' ? TvSeriesEndPoint : endPoint,
    (s: any) => {
      const { data } = s;
      if (data.data) {
        // getStudioList(`?page=1&limit=6`, data.data.studios[0]._id,"");
        console.log('DATAaaaa  =>>>>>>', data.data);
        productionType === 'TV Series' || type === 'set'
          ? dispatch(
              setSpendingPieChart(
                [...data?.data?.topFiveSpendings, ...data?.data?.others]?.map(
                  (item: any, i: number) => ({
                    ...item,
                    className: colorsClassNames[i],
                    color: colorsNames[i],
                  }),
                ),
              ),
            )
          : dispatch(
              setSpendingPieChart(
                data.data?.data?.map((item: any, i: number) => ({
                  ...item,
                  className: colorsClassNames[i],
                  color: colorsNames[i],
                })),
              ),
            );
        // setSecondDropdownOptions(data.data.studios)
      }
      dispatch(setCommonDataLoader(false));
    },

    (e: any) => {
      notify(e?.data?.message, 'error');
    },
  );
};

export const removePaiChartData = () => {
  const { dispatch } = store;
  dispatch(setSpendingPieChart([]));
};

export const getLocationAndEpisodeSetPieChartSpendings = (
  id?: any,
  type?: string,
  secondId?: any,
  locationId?: string,
  fromDate?: number,
  toDate?: number,
) => {
  const { dispatch } = store;
  dispatch(setCommonDataLoader(true));

  const dateParams = `${fromDate ? `&fromDate=${fromDate}` : ''}${
    toDate ? `&toDate=${toDate}` : ''
  }`;

  let endPoint = endPoints.production.locationAndEpisodePiaChartData;
  if (type === 'location') {
    endPoint += `?locationId=${id}${dateParams}`;
  } else if (type === 'episode') {
    endPoint = `${endPoints.production.spendingPiaChartData}?episodeId=${id}&productionId=${secondId}&filterType=production_schedule${dateParams}`;
  } else if (type === 'locationFromSet') {
    endPoint = `${endPoints.production.spendingPiaChartData}?productionId=${id}&setId=${secondId}&locationId=${locationId}&filterType=set_schedule${dateParams}`;
  }
  getApiCall(
    endPoint,
    (s: any) => {
      const { data } = s;
      if (data.data) {
        // getStudioList(`?page=1&limit=6`, data.data.studios[0]._id,"");
        console.log('DATAaaaaaaaaaaaaaa  =>>>>>>', data.data);
        data?.data?.topFiveSpendings
          ? dispatch(
              setSpendingPieChart(
                [...data?.data?.topFiveSpendings, ...data?.data?.others]?.map(
                  (item: any, i: number) => ({
                    ...item,
                    className: colorsClassNames[i],
                    color: colorsNames[i],
                  }),
                ),
              ),
            )
          : dispatch(
              setSpendingPieChart(
                data?.data?.data?.map((item: any, i: number) => ({
                  ...item,
                  className: colorsClassNames[i],
                  color: colorsNames[i],
                })),
              ),
            );
      }
      // setSecondDropdownOptions(data.data.studios)

      dispatch(setCommonDataLoader(false));
    },

    (e: any) => {
      notify(e?.data?.message, 'error');
    },
  );
};

export const getDashboardRedirectionAccess = (cb?: (data?: any) => void) => {
  const { dispatch } = store;
  // dispatch(setCommonDataLoader(true))

  // Build the API endpoint with the query and studioId
  const apiendpoint: string = endPoints.dashboardAccess;
  // Make the API call
  getApiCall(
    apiendpoint,
    (s: any) => {
      const { data } = s;

      dispatch(SetDashboardAccess(data?.data));
      // Callers that need the redirection logic to react to this call
      // immediately (rather than waiting for the redux selector to update
      // on the next render) can use this value directly.
      cb && cb(data?.data);
      // Stop loading indicator
      // dispatch(setCommonDataLoader(false))
    },
    (e: any) => {
      // Handle error, stop loading
      notify(e?.data?.message, 'error');
      cb && cb();

      // dispatch(setCommonDataLoader(false))
    },
  );
};

export const getDailyDeptSpendings = (params: string, _cb?: any) => {
  const { dispatch } = store;
  dispatch(setCommonDataLoader(true));

  let endPoint = endPoints.dashBoard.deptDailySpeindgs;

  endPoint = endPoint + params;

  getApiCall(
    endPoint,
    (s: any) => {
      const { data } = s;
      if (data.data) {
        // getStudioList(`?page=1&limit=6`, data.data.studios[0]._id,"");
        dispatch(setDailyDeptSpendings(data.data));
        // setSecondDropdownOptions(data.data.studios)
      }
      dispatch(setCommonDataLoader(false));
    },

    (e: any) => {
      notify(e?.data?.message, 'error');
    },
  );
};

export const getDepartmentLineChart = (params: string, _cb?: any) => {
  const { dispatch } = store;
  dispatch(setCommonDataLoader(true));

  let endPoint = endPoints.dashBoard.departmentLineChartdata;

  endPoint = endPoint + params;

  getApiCall(
    endPoint,
    (s: any) => {
      const { data } = s;
      if (data.data) {
        // getStudioList(`?page=1&limit=6`, data.data.studios[0]._id,"");
        dispatch(setDepartmentLineGraphData(data.data));
        // setSecondDropdownOptions(data.data.studios)
      }
      dispatch(setCommonDataLoader(false));
    },

    (e: any) => {
      notify(e?.data?.message, 'error');
    },
  );
};

export const getDepartmentPaiChart = (params: string, _cb?: any) => {
  const { dispatch } = store;
  dispatch(setCommonDataLoader(true));

  let endPoint = endPoints.dashBoard.departmentPaichartdata;

  endPoint = endPoint + params;

  getApiCall(
    endPoint,
    (s: any) => {
      const { data } = s;
      if (data.data) {
        // console.log('PaiChart =>>>>>>>', [
        //   ...data.data.topFiveSpendings,
        //   ...data.data.others,
        // ]);
        dispatch(
          setDepartmentPaiData(
            [...data.data.topFiveSpendings, ...data.data.others]?.map(
              (item: any, i: number) => ({
                ...item,
                className: colorsClassNames[i],
                color: colorsNames[i],
              }),
            ),
          ),
        );

        // setSecondDropdownOptions(data.data.studios)
      }
      dispatch(setCommonDataLoader(false));
    },

    (e: any) => {
      notify(e?.data?.message, 'error');
    },
  );
};

export const getOrderSettingData = async (
  productionId: string | null,
  cb?: any,
) => {
  const { dispatch } = store;
  dispatch(setOrderSettingData({}));
  await getApiCall(
    `${endPoints.dashBoard.getOrderApprovalLevels}?productionId=${productionId}`,
    (s: any) => {
      const { data } = s;
      if (data?.data) {
        dispatch(setOrderSettingData(data?.data));
        if (cb) cb();
      }
    },
    (e: any) => {
      notify(e?.data?.message, 'error');
    },
  );
  // await getApiCall(
  //   [
  //     {
  //       url: `${endPoints.dashBoard.getOrderRoles}?productionId=${productionId}`,
  //       dispatchFn: setOrderSettingData,
  //     },
  //     {
  //       url: `${endPoints.dashBoard.getOrderApprovalLevels}?productionId=${productionId}`,
  //       dispatchFn: setOrderSettingData,
  //       cb,
  //     },
  //   ],
  //   dispatch,
  // ).catch(error => {
  //   notify(error?.data?.message, 'error');
  // });
};
export const approvedContacts = (data: any, cb?: any) => {
  const endPoint = endPoints.dashBoard.approved;

  postApiCall(
    endPoint,
    data,
    (s: any) => {
      const {
        data: { statusCode, message },
      } = s;

      console.log('RESSS', s);
      if (statusCode && statusCode === 200) {
        notify(message, 'success');
        if (cb) cb();
      }
    },
    (e: any) => {
      if (e?.data && e?.data.message) {
        notify(e?.data.message, 'error');
      }
    },
  );
};

export const addCrewMembers = (data: any, cb?: any, errorcb?: any) => {
  const endPoint = endPoints.dashBoard.addCrewMembers;

  postApiCall(
    endPoint,
    data,
    (s: any) => {
      const {
        data: { statusCode, message },
      } = s;

      console.log('RESSS', s);
      if (statusCode && statusCode === 200) {
        notify(message, 'success');
        if (cb) cb();
      }
    },
    (e: any) => {
      if (e?.data && e?.data.message) {
        notify(e?.data.message, 'error');
        errorcb?.();
      }
    },
  );
};

export const addApproverLevel = (data: any, cb?: any, errorcb?: any) => {
  const endPoint = endPoints.order.addApproverLevel;

  postApiCall(
    endPoint,
    data,
    (s: any) => {
      const {
        data: { statusCode, message },
      } = s;

      if (statusCode && statusCode === 200) {
        notify(message, 'success');
        if (cb) cb();
      }
    },
    (e: any) => {
      if (e?.data && e?.data.message) {
        notify(e?.data.message, 'error');
        errorcb?.();
      }
    },
  );
};

export const editApproverLevel = (data: any, cb?: any, errorcb?: any) => {
  const endPoint = endPoints.order.addApproverLevel;

  putApiCall(
    endPoint,
    data,
    (s: any) => {
      const {
        data: { statusCode, message },
      } = s;

      if (statusCode && statusCode === 200) {
        notify(message, 'success');
        if (cb) cb();
      }
    },
    (e: any) => {
      if (e?.data && e?.data.message) {
        notify(e?.data.message, 'error');
        errorcb?.();
      }
    },
  );
};

export const getDashboardPieChartData = async (
  entityId: string | null,
  entityType: string,
  cb?: any,
  fromDate?: number,
  toDate?: number,
) => {
  const { dispatch } = store;
  dispatch(setOrderSettingData({}));
  const dateParams = `${fromDate ? `&fromDate=${fromDate}` : ''}${
    toDate ? `&toDate=${toDate}` : ''
  }`;
  await getApiCall(
    `${endPoints.getDashboardPieData}?entityId=${entityId}&entityType=${entityType}${dateParams}`,
    (s: any) => {
      const { data } = s;
      if (data?.data) {
        console.log(data?.data, 'data?.datadata?.data');
        dispatch(
          setDashboardPiechartData(
            [...data.data.topFiveSpendings, ...data.data.others]?.map(
              (item: any, i: number) => ({
                ...item,
                className: colorsClassNames[i],
                color: colorsNames[i],
              }),
            ),
          ),
        );
        if (cb) cb();
      }
    },
    (e: any) => {
      notify(e?.data?.message, 'error');
    },
  );
  // await getApiCall(
  //   [
  //     {
  //       url: `${endPoints.dashBoard.getOrderRoles}?productionId=${productionId}`,
  //       dispatchFn: setOrderSettingData,
  //     },
  //     {
  //       url: `${endPoints.dashBoard.getOrderApprovalLevels}?productionId=${productionId}`,
  //       dispatchFn: setOrderSettingData,
  //       cb,
  //     },
  //   ],
  //   dispatch,
  // ).catch(error => {
  //   notify(error?.data?.message, 'error');
  // });
};
